var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconArrowLeftGray16({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2 3.9999L7.19999 7.9999L11.2 11.9999L10.4 13.5999L4.79999 7.9999L10.4 2.3999L11.2 3.9999Z",
    fill: "#B7B7B7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArrowLeftGray16);
export default __webpack_public_path__ + "static/media/icon_arrow_left_gray_16.e6c21b4fb9f4295b947c3417eaa92762.svg";
export { ForwardRef as ReactComponent };